// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vIQA","type":"styles_type__xL8eE","choices":"styles_choices__3oI0d"};